import {Component, ElementRef, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output, Renderer2, ViewChild} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR} from '@angular/forms';
import * as _ from 'lodash';
import {SelectInputOption} from './models/select-input-option';
import {Subscription} from 'rxjs';

@Component({
  	selector: 'app-select-input-indra',
  	templateUrl: './select-input-indra.component.html',
		styleUrls: ['./select-input-indra.component.scss'],
		providers: [
			{
				provide: NG_VALUE_ACCESSOR,
				useExisting: forwardRef(() => SelectInputIndraComponent),
				multi: true
			}
		]
})
export class SelectInputIndraComponent implements ControlValueAccessor, OnInit, OnDestroy {
	public form: FormGroup = this.fb.group({
		select: [null]
	});
	private _value: any;
	private sub$: Subscription;
	// private isOpen = false;

	@ViewChild('select')
	public select: ElementRef;
	
	@Input()
	public label = '';
	
	@Input()
	public selectLabel = '';

	@Input()
	public selectId:string;

	@Input()
	public placeholder = '';

	@Input()
	public options: Array<SelectInputOption> = [];

	@Input()
	public optionsTranslated = false;

	@Input()
	public errorClass = '';
	
	@Input()
	public isValueComplexObject = false;

	@Output() selectionChanged: EventEmitter<any> = new EventEmitter<any>();

	get isLabel(): boolean {
		return !_.isEmpty(this.label);
	}

	set value(value: any) {
		this._value = value;
		this.form.patchValue({ select: this.value }, {emitEvent: false});
		this.propagateChange(this.value);
		this.selectionChanged.emit(this.value);
	}

	get value() {
		return this._value;
	}

	get hasPlaceholder(): boolean {
		return !_.isEmpty(this.placeholder);
	}

	get isUnselected(): string {
		return this.hasPlaceholder ? 'is-unselected' : '';
	}

	// get openClass(): string {
	// 	return this.isOpen ? 'is-open' : '';
	// }

	propagateChange = (n: any) => { };
	onTouched = (n: any) => { };

	trackByFn = (index: number, item: any) => index;

	constructor(
		private fb: FormBuilder,
		private renderer: Renderer2
	) { }

	ngOnInit() {
		this.sub$ = this.form.get('select').valueChanges.subscribe(value => {
			this.writeValue(value);
		});
	}

	ngOnDestroy() {
		if (this.sub$) this.sub$.unsubscribe();
	}

	writeValue(value: any) {
		if (!_.isEqual(this.value, value)) {
			this.value = value;
		}
	}

	registerOnChange(fn) {
		this.propagateChange = fn;
	}

	registerOnTouched(fn) { 
		this.onTouched = fn; 
	}

	setDisabledState(isDisabled: boolean): void {
		if (isDisabled) {
			this.renderer.setAttribute(this.select.nativeElement, 'disabled', (<any>isDisabled));
		} else {
			this.renderer.removeAttribute(this.select.nativeElement, 'disabled');
		}
	}

	// handleOpen() {
	// 	this.isOpen = !this.isOpen;
	// 	this.onTouched(null); 
	// }
}
